<template lang="pug">
  .employees-list
    .field(v-for="field in fields")
      h3 {{ field.name }}
      .employee(v-for="employee in employees[field.name]", :key="employee.id")
        span.name
          a(href="#", @click.prevent="loginAs(employee.id)", v-if="user.is_superuser")
            i.fa.fa-eye
          |  {{ employee.short_name }}
        span.cell-phone
          a(:href="'tel:' + employee.cell_phone") {{ employee.cell_phone }}
        span.email
          a(:href="'mailto:' + employee.email")
            i.fa.fa-envelope
</template>

<script>
export default {
  name: 'EmployeesList',
  props: ['fields', 'user'],
  data () {
    return {
      employees: {}
    }
  },
  methods: {
    loginAs: function (userId) {
      let loginToken = this.$parent.$parent.loginToken
      this.$http.get('/login-as-user/' + userId)
        .set({Authorization: 'jwt ' + loginToken})
        .then(response => {
          this.$emit('login-as', response.body.token)
        })
    }
  },
  watch: {
    fields: function (newFields, oldFields) {
      let app = this
      let loginToken = this.$parent.$parent.loginToken
      for (let field of this.fields) {
        this.$http.get('/users/?shift_types__field=' + field.id)
          .set({Authorization: 'jwt ' + loginToken})
          .then(function (response) {
            let newData = {}
            newData[field.name] = response.body
            app.employees = Object.assign({}, app.employees, newData)
          })
      }
    }
  }
}
</script>


<style lang="sass" scoped>
h3
  font-weight: bold
  border-bottom: 1px solid #4a4a4a
  margin-bottom: 2em

.field > .field
  margin-top: 4em

.employee
  display: grid
  grid-template-columns: 120px auto 30px
  grid-template-rows: 35px

  .name
    grid-column-start: 1
  .cell-phone
    grid-column-start: 2
  .email
    grid-column-start: 3
    text-align: right

    a
      color: #999

</style>



// WEBPACK FOOTER //
// EmployeesList.vue?a770f10e